import { Helmet } from "react-helmet-async";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Pagebanner from "../../layout/Banner";
import ContactForm from "../../Components/HomeSections/ContactForm";

const ContactUS = () => {
  const brandGold = "#E3B66B";
  const darkGreen = "#0A1D1B";
  return (
    <>
    <Helmet>
  <title>Contact R & P Law Partners | Get Legal Consultation </title>

  <meta
    name="description"
    content="Contact R & P Law Partners for trusted legal advice and schedule a consultation with experienced advocates for your legal concerns."
  />

  <meta
    name="keywords"
    content="Contact Us"
  />

  <link
    rel="canonical"
    href="https://rplawpartners.com/contact-us"
  />

  <noscript>
    Please enable JavaScript to view this page properly.
  </noscript>
</Helmet>

      <Header />
      <Pagebanner title="Contact Us" />
      <ContactForm />
      <Footer />
    </>
  );
};

export default ContactUS;

